import { useEffect, useState } from "react";
import axios from "../../../../api/axiosConfig";

export function usePedidoData(usuario) {
  const [productos, setProductos] = useState([]);
  const [mesas, setMesas] = useState([]);
  const [meseros, setMeseros] = useState([]);

  useEffect(() => {
    obtenerProductos();
    obtenerMesas();
    obtenerMeseros();
  }, []);

  const obtenerProductos = async () => {
    try {
      const res = await axios.get("/productos");
      setProductos(res.data || []);
    } catch (e) {
      console.error("Error productos", e);
    }
  };

  const obtenerMesas = async () => {
    try {
      const res = await axios.get("/mesas");
      setMesas(res.data || []);
    } catch (e) {
      console.error("Error mesas", e);
    }
  };

  const obtenerMeseros = async () => {
    try {
      const res = await axios.get("/usuarios");
      const lista = res.data || [];
      setMeseros(lista);
    } catch (e) {
      console.error("Error meseros", e);
    }
  };

  return { productos, mesas, meseros };
}
